import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'bulkProductDrawer.title',
    defaultMessage: 'Add multiple products',
    description: 'Title of the bulk product drawer',
  },
  columns: {
    sku: {
      id: 'bulkProductDrawer.columns.sku',
      defaultMessage: 'SKU',
      description: 'Label of the spreadsheet column sku',
    },
    quantity: {
      id: 'bulkProductDrawer.columns.quantity',
      defaultMessage: 'Quantity',
      description: 'Label of the spreadsheet column quantity',
    },
  },
};

export default defineMessages(translations);
